// src/strings/footerStrings.js
const footerStrings = {
  en: {
    copyright: "All rights reserved.",
    quickLinks: "Quick Links",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    github: "GitHub Repository",
    resources: "Resources",
    followUs: "Follow Us",
    team: "Our Team",
    teamDescription: "Built by a passionate team of students",
    address: "Cairo, Egypt",
    email: "Contact us",
    installApp: "Install App",
    installAppDescription: "Get the app for a better experience",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    feedback: "Feedback & Bugs",
  },
  ar: {
    copyright: "جميع الحقوق محفوظة.",
    quickLinks: "روابط سريعة",
    aboutUs: "عن البرنامج",
    contactUs: "تواصل معنا",
    github: "مستودع GitHub",
    resources: "الموارد",
    followUs: "متابعتنا",
    team: "فريقنا",
    teamDescription: "تم بناؤه من قبل فريق طلابي متحمس",
    address: "القاهرة، مصر",
    email: "تواصل معنا",
    installApp: "تثبيت التطبيق",
    installAppDescription: "احصل على التطبيق لتجربة أفضل",
    terms: "شروط الخدمة",
    privacy: "سياسة الخصوصية",
    feedback: "التعليقات والأخطاء",
  },
};

export default footerStrings;
